import { Component, ViewChild, ViewChildren, QueryList } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { CSVService  } from '@tools';
import { DxAspNetDataXsrfAwareService, UuidService } from '@tools';
import { Config } from '@config';
import { UrlEnhancerService } from '@url';
import { AuthHttp } from '@http';
import { LanguageService, __i18n } from '@localisation';
import { TenantService } from '@tenant';
import { lastValueFrom, Subject } from 'rxjs';
import { TimeDateConverterService } from '@converter';
import { ChangeDetectorRef } from '@angular/core';
import { MessagesService, MessageType } from '@ui-messages';
import { ClxCheckBoxComponent } from '@forms/clx-forms/controls/clx.checkbox.component';
import { ClxButtonComponent } from '@forms/clx-forms/controls/clx.button.component';
import { ClxDateTimeComponent } from '@forms/clx-forms/controls/clx.datetime.component';

@Component({
    selector: 'batch-upgrade-list',
    templateUrl: './batch-upgrade-list.template.html',
    standalone: false
})
export class BatchUpgradeListComponent {

    constructor(
        private dxAspNetXsrfAwareService: DxAspNetDataXsrfAwareService,
        private urlEnhancer: UrlEnhancerService,
        private config: Config,
        private tenantService: TenantService,
        private languageService: LanguageService,
        private urlEnhancerService: UrlEnhancerService,
        private http: AuthHttp,
        private csvService: CSVService,
        private timeDateConverterService:TimeDateConverterService,
        private ref: ChangeDetectorRef,
        private uuidService: UuidService,
        private messagesService: MessagesService,
    ){}

    @ViewChild('ExportButton')
    private clxButton: ClxButtonComponent;

    @ViewChild('changeAllBox')
    public changeAllBox: ClxCheckBoxComponent;

    @ViewChild('startTime')
    public startTimeUIControl: ClxDateTimeComponent;

    @ViewChildren('batchCheckboxes')
    public batchCheckboxes: QueryList<ClxCheckBoxComponent>;

    public testId: string = 'batch-upgrade.list';
    public id: string = 'batch-update-list';
    public exportTestId: string = 'batch-upgrade-export.list';
    public exportId: string = 'batch-update-export-list';

    public exportButtonDisabled: boolean = true;

    private allBatchesDataSource: DataSource;
    public source: DataSource
    public exportSource: DataSource

    public exportDialogVisible: boolean = false
    public exportDialogMinDateTime: Date = new Date()

    public exportButtonText: string = 'Export';

    public async ngOnInit() {
        this.source = this.setDataSource();
        this.allBatchesDataSource = this.setAllBatchIdsDataSource();
        await this.allBatchesDataSource.load();        
        this.exportButtonDisabled = true;
    }

    public selectAllBatches : boolean = false;

    public allBatchUpgradeIds: any[] = [];

// select=["SiteBatchUpgradeId"]&requireTotalCount=true&tenantId=d262d3df-fe70-4824-91b0-43246aa31136&locale=en-US&_=1734614862039

    public setDataSource() {
        const tenantId = this.tenantService.getCurrentTenantId();
        const locale = this.languageService.language;
        const url = this.urlEnhancer.replaceParams(this.config.services.upgrade.batchUpgradeList)

        return new DataSource({
            store: this.dxAspNetXsrfAwareService.createStore({
                loadUrl: url,
                loadMethod: 'POST',
                key: 'SiteBatchUpgradeId',
                onBeforeSend: (op, settings) => {
                    settings.data.tenantId = tenantId;
                    settings.data.locale = locale;
                },
            })
        })
    }

    public setAllBatchIdsDataSource() {
        const tenantId = this.tenantService.getCurrentTenantId();
        const locale = this.languageService.language;
        const url = this.urlEnhancer.replaceParams(this.config.services.upgrade.batchUpgradeList)

        return new DataSource({
            store: this.dxAspNetXsrfAwareService.createStore({
                loadUrl: url,
                loadMethod: 'POST',
                key: 'SiteBatchUpgradeId',
                onBeforeSend: (op, settings) => {
                    settings.data.tenantId = tenantId;
                    settings.data.locale = locale;
                    settings.data.skip = 0;
                    settings.data.take = undefined;
                    settings.data.select = "[\"SiteBatchUpgradeId\"]";
                    settings.data.requireTotalCount = true;
                },
                onLoaded:(result) =>
                {
                    this.allBatchUpgradeIds = result.map((current)=>{return current.SiteBatchUpgradeId});
                }
            })
        })
    }

    public remoteOperations: any = {
        paging: true, filtering: true, sorting: true, grouping: true, summary: true, groupPaging: true
    };

    public exportRemoteOperations: any = {
        paging: true, filtering: true, sorting: true, grouping: true, summary: true, groupPaging: true
    };

    public async showExportDialog()
    {        
        this.exportDialogVisible = !this.exportDialogVisible;
        if (this.exportDialogVisible && this.exportSource == null)
        {
            this.exportSource = this.setDataSource();            
        }
        this.changeAllBatchesSelection(false);
    }

    public async exportSelectorChanged()
    {
        if (this.startTimeUIControl) this.startTimeUIControl.value = "";
        this.changeAllBatchesSelection(false);        
        this.exportButtonText = 'Export';
        this.exportButtonDisabled = true;
        this.ref.markForCheck();
        
    }

    public exportStartDateTimeChanged(event)
    {   
        if (!isNaN (this.startTimeUIControl.value) && this.startTimeUIControl.value != undefined && this.startTimeUIControl.value != "") 
        {
            this.exportButtonDisabled = false
        }
        else
        {
            this.exportButtonDisabled = true
        }
        
        // this.exportButtonDisabled = (event == undefined) || (event == null) || (isNaN(event)) || event == "";
        this.exportButtonText = 'Export';
        this.ref.markForCheck();
    }

    public changeAllBatchesSelection(value : boolean)
    {
        this.selectAllBatches = value;
        this.changeAllBox.setValue(value)
        this.selectedBatches = value ? this.allBatchUpgradeIds : [];
        this.oldSelectAllBatches = value;
        this.batchCheckboxes.forEach((control) => control.value = value)
        
        if (value ===  true)
        {
            this.exportButtonDisabled = false;
        }
        else
        {
            this.exportButtonDisabled = true;
        }
        this.updateExportButtonLabelCounter();
        this.ref.markForCheck();
    }

    private updateExportButtonLabelCounter()
    {
        this.exportButtonText = 'Export (' + this.innerSelectedBatches.length + '/' + this.allBatchUpgradeIds.length + ')';
    }

    private oldSelectAllBatches : boolean = false;
    public selectBatch(id, batchId, field){             
        if(id) {
            if(!this.selectedBatches.includes(batchId)) {
                this.selectedBatches.push(batchId);
            }
        }else{
            this.selectedBatches = this.selectedBatches.filter((current) => current !== batchId)
            this.oldSelectAllBatches = false;
            this.selectAllBatches = false;
            this.changeAllBox.setValue(false)
        }
        if (this.innerSelectedBatches.length > 0)
        {
            this.exportButtonDisabled = false
        }
        else
        {
            this.exportButtonDisabled = true
        }
        this.updateExportButtonLabelCounter();
        this.ref.markForCheck();
    }

    private innerSelectedBatches  : string[] = [];

    public set selectedBatches(value: string[]) {
        this.innerSelectedBatches = value;
    }

    public get selectedBatches(){
        return this.innerSelectedBatches;
    }
    
    public async doExport(event)
    {
        const tenantId = this.tenantService.getCurrentTenantId();
        
        if (event.values.exportCriteria === 'DateTime')
        {                        
            const date = new Date(event.values.startTime);
            const url = this.urlEnhancerService.replaceParams(this.config.services.plant.batchUpgradeExportByDate,{
                tenantId: tenantId,
                startDate: this.timeDateConverterService.convertFormat(date, "YYYY-MM-DD HH:mm:ss")
            });
            try
            { 
                let JsonResult = await lastValueFrom(this.http.get(url));
                if (JsonResult.body == "[]")
                {
                    this.exportDialogVisible = false;
                    this.ref.markForCheck();
                    this.messagesService.addMessage({
                        text: $localize`:@@plant.batchupgrade.status.export.success:no rows to export!`,
                        type: MessageType.error
                    });
                }
                else
                {
                    let csvResult = this.csvService.objectArrayToCSV(JSON.parse(JsonResult.body),",");
                    this.downloadStringAsFile("BatchUpgradeStatus-T" + tenantId + "-" + this.timeDateConverterService.convertFormat(new Date(), "YYYY-MM-DD HH.mm.ss") +".csv", csvResult);
                    this.exportDialogVisible = false;                    
                    this.ref.markForCheck();
                    this.messagesService.addMessage({
                        text: $localize`:@@plant.batchupgrade.status.export.success:export successful`,
                        type: MessageType.success
                    });
                }
            }
            catch
            {
                this.exportDialogVisible = false;
                this.ref.markForCheck();
                this.messagesService.addMessage({
                    text: $localize`:@@plant.batchupgrade.status.export.error:an unexpected error occurred`,
                    type: MessageType.error
                });
            }
        }
        if (event.values.exportCriteria === 'GuidList')
        {                      
            if (this.allBatchUpgradeIds.length > 0)
            {
                const url = this.urlEnhancerService.replaceParams(this.config.services.plant.batchUpgradeExportByIdList,{
                    tenantId: tenantId
                });
                try
                {
                    let JsonResult = await lastValueFrom(this.http.postJSON(url, this.innerSelectedBatches));                    
                    if (Array.isArray(JsonResult) && JsonResult.length === 0)
                    {
                        this.exportDialogVisible = false;
                        this.ref.markForCheck();
                        this.messagesService.addMessage({
                            text: $localize`:@@plant.batchupgrade.status.export.norows:no rows to export!`,
                            type: MessageType.error
                        });
                    }
                    else
                    {
                        let csvResult = this.csvService.objectArrayToCSV(JsonResult,",");
    
                        this.downloadStringAsFile("BatchUpgradeStatus-T" + tenantId + "-" + this.timeDateConverterService.convertFormat(new Date(), "YYYY-MM-DD hh.mm.ss") +".csv", csvResult);
                        this.exportDialogVisible = false;
                        this.ref.markForCheck();
                        this.messagesService.addMessage({
                            text: $localize`:@@plant.batchupgrade.status.export.success:export successful`,
                            type: MessageType.success
                        });
                    }
                }
                catch
                {
                    this.exportDialogVisible = false;
                    this.ref.markForCheck();
                    this.messagesService.addMessage({
                        text: $localize`:@@plant.batchupgrade.status.export.error:an unexpected error occurred`,
                        type: MessageType.error
                    }); 
                }
            }
        }
    }
    private downloadStringAsFile(filename: string, content: string) {
        const blob = new Blob([content], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
    }
}